import React from "react"
import ButtonLink from "./button-link"

const EmailLink = ({ data }) => {
  data.url = `mailto:${data.emailAddress}`
  return <ButtonLink button={data} appearance={data.type} key={data.id} />
}

export default EmailLink
